// @flow

export default class EscapedCSS {
  _private_safe_value: string;

  static factory(input: string | EscapedCSS): EscapedCSS {
    return input instanceof EscapedCSS ? input : new EscapedCSS(String(input));
  }

  constructor(unsafeCSS: string) {
    this._private_safe_value = unsafeCSS
      .trim()
      .replace('>', '\u003E')
      .replace('<', '\u003C')
      .replace('&', '\u0026')
      .replace('"', '\u0022')
      .replace("'", '\u0027');
  }

  toString() {
    return this._private_safe_value;
  }
}
